import { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { uploadInvoice } from "actions/orderActions";
import Loading from "components/Loading";
import {
    Modal,
    ModalBody,
    ModalFooter
} from "reactstrap";

function Modaluploadinvoice(props) {
    const [_id] = useState(props.uploadinvoice._id.split(","));
	const [file_to_upload_invoice, setFileToUploadInvoice] = useState("");

    var { isLoading } = props.order;
    var { isOpenModalUploadInvoice, openModal, uploadInvoice } = props;
    const { t } = useTranslation();
    
    useEffect(() => {
        if (file_to_upload_invoice !== "") {
            const formData = new FormData();
            _id.forEach((id) => {
                formData.append("_id", id);
            });
            formData.append('file', file_to_upload_invoice);

            uploadInvoice({ formData, page: props.uploadinvoice.page, sizePerPage: props.uploadinvoice.sizePerPage, searchText: props.uploadinvoice.searchText, filter_printer: props.uploadinvoice.filter_printer, filter_shop_code: props.uploadinvoice.filter_shop_code, filter_status: props.uploadinvoice.filter_status, filter_work_status: props.uploadinvoice.filter_work_status, filter_staff: props.uploadinvoice.filter_staff, filter_order_design: props.uploadinvoice.filter_order_design, filter_shipping_type: props.uploadinvoice.filter_shipping_type }, openModal);
        }
    }, [file_to_upload_invoice]); // eslint-disable-line react-hooks/exhaustive-deps

	const onChange = (e) => {
        if (e.target.name === "file_to_upload_invoice") {
            setFileToUploadInvoice(e.target.files[0]||"");
        }
	};

    const onOpenModal = () => {
        openModal();
    };

    return (
        <Fragment>
            <Modal centered={true} size="lg" toggle={() => { onOpenModal() }} isOpen={isOpenModalUploadInvoice} className="al-d-none-option-react-select">
                <Loading isLoading={isLoading} />
                <div className="modal-header">
                    <h1 className="mb-0 text-dark">{t("Upload Invoice")}</h1>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                        <i className="ki-outline ki-cross fs-1" onClick={() => { onOpenModal() }} ></i>
                    </div>
                </div>
                <ModalBody>
                    <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                            <span className="">{t("Select file to upload invoice")}</span>
                        </label>
                        <div className="al-custom-file">
                            <input className="al-custom-file-input" type="file" name="file_to_upload_invoice" accept=".xml,text/xml,application/xml" onChange={(e) => { onChange(e) }} />
                            <label className="al-custom-file-label">Choose file</label>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button type="reset" id="kt_modal_users_search_reset" data-bs-dismiss="modal" className="btn btn-active-light me-3" onClick={() => { onOpenModal() }} >{t("Cancel")}</button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}

Modaluploadinvoice.propTypes = {
    uploadInvoice: PropTypes.func.isRequired
};
const mapStateToProps = state => ({
    order: state.order,
    user: state.user
});
const mapDispatchToProps = {
    uploadInvoice
}

export default connect(mapStateToProps, mapDispatchToProps)(Modaluploadinvoice);